import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// for styling
/********/
  // import 'bootstrap'
/*******/
import 'bootstrap/dist/css/bootstrap.min.css'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '../public/css/custom.css'
import '../public/css/compiled-sass.css'
import '../public/css/vessel-audit/non-conformity.css'
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
Vue.use(LottieVuePlayer);
// font awesome
window.$=require('jquery');
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faThLarge,
  faFolderOpen,
  faClipboard,
  faShip,
  faChartLine,
  faBars,
  faUser,
  faUserTie,
  faSignInAlt,
  faSignOutAlt,
  faPlusSquare,
  faEye,
  faEyeSlash,
  faNotesMedical,
  faFileContract,
  faInfoCircle,
  faFileSignature,
  faChevronLeft,
  faPen,
  faBan,
  faSave,
  faUpload,
  faFilePdf,
  faFile,
  faTrash,
  faCogs,
  faDownload,
  faUsers,
  faPlus,
  faAnchor,
  faList,
  faMoneyBill,
  faCalendar,
  faCertificate,
  faLandmark,
  faCarCrash,
  faCheckDouble,
  faFileExcel,
  faSearch,
  faQuestionCircle,
  faCheck,
  faEnvelope,
  faTimes,
  faCog,
  faChevronDown,
  faChevronRight,
  faSpinner,
  faShare,
  faFilter,
  faArrowLeft,
  faArrowRight,
  faBriefcase,
  faArrowUp,
  faArrowDown,
  faCalculator,
  faCircle,
  faSquare,
  faStar,
  faChevronUp,
  faBuilding,
  faCaretSquareDown,
  faLongArrowAltDown,
  faSortDown,
  faSort,
  faFolderPlus, faBullhorn, faPercent,
  faFileMedical,
  faShieldAlt, faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import Vue2Editor from "vue2-editor";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";


Vue.use(Vue2Editor)
Vue.use(VueGoodTablePlugin)
Vue.component('apexchart', () => import('vue-apexcharts'))
Vue.component('vueeditor',Vue2Editor)

// Axios in Global Service
import {GlobalService} from './services/GlobalService'
import {AlertService} from './services/AlertService'
import {DateService} from "@/services/DateService";

library.add(faThLarge,
  faFolderOpen,
  faClipboard,
  faShip,
  faChevronRight,
  faChartLine,
  faBars,
  faUser,
  faUserTie,
  faSignInAlt,
  faSignOutAlt,
  faPlusSquare,
  faEye,
  faEyeSlash,
  faNotesMedical,
  faFileContract,
  faInfoCircle,
  faFileSignature,
  faChevronUp,
  faChevronLeft,
  faPen,
  faBan,
  faSave,
  faCheckDouble,
  faCheckCircle,
  faFilePdf,
  faTrash,
  faCogs,
  faFile,
  faUpload,
  faDownload,
  faUsers,
  faPlus,
  faAnchor,
  faList,
  faMoneyBill,
  faCalendar,
  faCertificate,
  faLandmark,
  faCarCrash,
  faFileExcel,
  faSearch,
  faQuestionCircle,
  faCheck,
  faTimes,
  faCog,
  faChevronDown,
  faEnvelope,
  faSpinner,
  faThLarge,
  faShare,
  faFilter,
  faArrowLeft,
  faBriefcase,
  faArrowUp,
  faArrowDown,
  faCalculator,
  faCircle,
  faSquare,
  faStar,
  faBuilding,
  faCaretSquareDown,
  faLongArrowAltDown,
  faSortDown,
  faSort,
  faArrowRight,
  faFolderPlus,
  faBullhorn,
  faFileMedical,
  faShieldAlt,
  faPercent,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
GlobalService.initializeAxios()
AlertService.initializeSwal();

Vue.prototype.$formatDate = (date, format = 'default') => {
  if (!date) {
    return ''
  }

  const newDate = new Date(date)

  if (format === 'withTime') {
    const datePart = new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(newDate)

    const timePart = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(newDate)

    return `${datePart} - ${timePart}`
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: format === 'long' ? 'long' : 'short',
    year: 'numeric'
  }).format(newDate)
}

(function (parameters) {
  const VueFilters = {
    toInt: function(item) {
      return item ? parseInt(item) : 0;
    },
    toUpper: function (item){
      return typeof item === 'string' || item instanceof String ?  item.toUpperCase() : item;
    },
    toYesOrNo: function (item){
      return item ? 'Yes' : 'No';
    },
    strTitle: function(str) {
      return (str + '').replace(/\w\S*/g, txt => (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));
    },
    eliteDate: function(date) {
      return DateService.dateEliteFormat(date);
    },
  };

  Object.keys(VueFilters).forEach(filter_name => {
    Vue.filter(filter_name, VueFilters[filter_name]);
  });
})();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
